import React from "react";
import { connect } from "react-redux";
import TerminalSubjectList from "../../components/TerminalSubjectList/TerminalSubjectList";
import Layout from "../../components/shared/Layout/Layout";

const TerminalSubjectListPage = () => {
  return (
    <div className="bg_light">
      <Layout title="Terminal Subjects">
        <TerminalSubjectList />
      </Layout>
    </div>
  );
};

export default TerminalSubjectListPage;
